import axios from "axios";
import create from "zustand";
import { getAllOrdersUrl, getOrderDetailsUrl, updateOrderActionUrl } from "../Utility/Url";
import { LogSuccess, Toastr } from "../Utility/UtilityFunctions";
import useUtilityStore from "./UtilityStore";

const { setLoading, setLoadingSearch } = useUtilityStore.getState();

const useOrderStore = create((set) => ({
  orderList: [],
  setOrderList: (value) => set({ orderList: value }),

  orderListTemp: [],
  setOrderListTemp: (value) => set({ orderListTemp: value }),

  orderListPagination: {},
  setOrderListPagination: (value) => set({ orderListPagination: value }),

  orderStatusTable: "",
  setOrderStatusTable: (value) => set({ orderStatusTable: value }),

  orderDetails: {},
  setOrderDetails: (value) => set({ orderDetails: value }),

  showOrderDownloadUI: false,
  setShowOrderDownloadUI: (value) => set({ showOrderDownloadUI: value }),

  showOrderDetails: false,
  setShowOrderDetails: (value) => set({ showOrderDetails: value }),

  searchOrderValue: "",
  setSearchOrderValue: (value) => set({ searchOrderValue: value }),

  paginationUrl: "",
  setPaginationUrl: (value) => set({ paginationUrl: value }),

  customerOrderHistoryPaginationUrl: "",
  setCustomerOrderHistoryPaginationUrl: (value) => set({ customerOrderHistoryPaginationUrl: value }),

  dropdownItem: "all orders",
  setDropdownItem: (value) => set({ dropdownItem: value }),

  openedAccordion: 0,
  setOpenedAccordion: (value) => set({ openedAccordion: value }),

  orderTakeAmount: { take: 10 },
  setOrderTakeAmount: (name, value) => set((state) => (state.orderTakeAmount[name] = value)),
}));

export default useOrderStore;

// green: get all orders list
export const getAllOrderList = async (
  filterStatus,
  paginationUrl = "",
  shopID = ""
) => {

  const { orderTakeAmount } = useOrderStore.getState();

  try {
    setLoading(true);

    let targetUrl = "";

    if (paginationUrl !== "") {
      // targetUrl = paginationUrl.indexOf("?");
      paginationUrl = JSON.stringify(paginationUrl);
      targetUrl = paginationUrl.slice(
        paginationUrl.indexOf("?"),
        paginationUrl.length - 1
      );
      targetUrl = getAllOrdersUrl + targetUrl;
      console.log("targetUrl:::", targetUrl);
    } else {
      targetUrl = getAllOrdersUrl;
    }

    console.log("targetUrl:::", targetUrl);

    let res = {};

    if (filterStatus && filterStatus !== "all orders") {
      if (shopID) {
        console.log("SHOP ID WITH STATUS !!!!!!");
        res = await axios.post(targetUrl, {
          take: 5,
          status: filterStatus,
          shop_id: shopID,
        });
      } else {
        res = await axios.post(targetUrl, {
          take: orderTakeAmount.take,
          status: filterStatus,
        });
      }
    } else {
      if (shopID) {
        console.log("ONLY SHOP ID");
        res = await axios.post(targetUrl, {
          take: 5,
          shop_id: shopID,
        });
      } else {
        res = await axios.post(targetUrl, { take: orderTakeAmount.take });
      }
    }

    console.log("getAllOrderList res.data:::: ", res.data);
    // res?.data?.data?.data?.map(item =>
    //   LogSuccess("Order Status: " + item?.status)
    // );

    if (res.data.success) {
      useOrderStore.getState().setOrderList(res.data.data.data);
      useOrderStore.getState().setOrderListTemp(res.data.data.data);
      useOrderStore.getState().setOrderListPagination(res.data.data);
      // Toastr({ message: res.data.message, type: "success" });
    } else {
      Toastr({ message: res.data.message, type: "error" });
    }
    setLoading(false);
  } catch (error) {
    console.log("getAllOrderList: ", error);
    Toastr({ message: "An error occurred!", type: "error" });
    setLoading(false);
  }
};

// blue: get order details
export const getOrderDetails = async (id) => {
  try {
    setLoading(true);

    const res = await axios.post(getOrderDetailsUrl, {
      id: id,
    });

    console.log("getOrderDetails res.data:::: ", res.data);

    if (res.data.success) {
      useOrderStore.getState().setOrderDetails(res.data.data);
      // Toastr({ message: res.data.message, type: "success" });
    } else {
      Toastr({ message: res.data.message, type: "error" });
    }
    setLoading(false);
  } catch (error) {
    console.log("getOrderDetails: ", error);
    Toastr({ message: "An error occurred!", type: "error" });
    setLoading(false);
  }
};

// blue: update order action
export const updateOrderAction = async (updateID = "", updateStatus = "", paginationUrl = "", autoRefresh = true, cancellationNote = "") => {

  console.log("updateID  updateStatus  paginationUrl", updateID, updateStatus, paginationUrl);

  try {
    setLoading(true);

    let res = {};
    if (cancellationNote)
      res = await axios.post(updateOrderActionUrl, {
        id: updateID,
        action: updateStatus,
        note: cancellationNote,
      });
    else
      res = await axios.post(updateOrderActionUrl, {
        id: updateID,
        action: updateStatus,
      });

    console.log("updateOrderAction res.data:::: ", res.data);

    if (res.data.success) {
      if (autoRefresh) getAllOrderList("", paginationUrl, "");
      getOrderDetails(updateID);
      // Toastr({ message: res.data.message, type: "success" });
      setLoading(false);
      return true;
    } else {
      Toastr({ message: res.data.message, type: "error" });
      setLoading(false);
      return false;
    }
  } catch (error) {
    console.log("updateOrderAction: ", error);
    Toastr({ message: "An error occurred!", type: "error" });
    setLoading(false);
    return false;
  }
};


// green: search order list
export const searchOrdersList = async (searchValue, url = "", take = 10) => {
  try {
    setLoadingSearch(true);
    console.log("searchValue::", searchValue);
    const res = await axios.post(url === "" ? getAllOrdersUrl : url, {
      search: searchValue,
      take: take,
    });

    console.log("searchOrdersList::: res.data", res.data);

    if (res.data.success) {
      useOrderStore.getState().setOrderList(res.data.data.data);
      useOrderStore.getState().setOrderListTemp(res.data.data.data);
      useOrderStore.getState().setOrderListPagination(res.data.data);
      setLoadingSearch(false);
      return true;
    } else {
      Toastr({ message: res.data.message, type: "error" });
      console.log("searchOrdersList: ", res.data.message);
      setLoadingSearch(false);
      return false;
    }
  } catch (error) {
    console.log("searchOrdersList: ", error);
    Toastr({ message: "An error occurred!", type: "error" });
    setLoadingSearch(false);
    return false;
  }
};
